import { createStyles } from '@mantine/core';

const useSidePanelStyle = createStyles((theme) => ({
  sidePanel: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 18,
  },

  fixedSidePanel: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 18,
    [theme.fn.largerThan('sm')]: {
      position: 'sticky',
      top: '90px',
      padding: 4,
    },
  },
}));

const SidePanel = ({ children, fixed = false, ...props }) => {
  const { classes } = useSidePanelStyle();
  return (
    <div
      className={fixed ? classes.fixedSidePanel : classes.sidePanel}
      {...props}
    >
      {children}
    </div>
  );
};

export default SidePanel;
